import React from 'react';

interface ProductRangeApplyStatusProps {
  status: 'idle' | 'applying' | 'success' | 'error'
  error: string | null
}

export const ProductRangeApplyStatus: React.FC<ProductRangeApplyStatusProps> = ({ status, error }) => {
  if (status === 'idle') {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed right-6 top-6 z-50 flex items-center gap-3 rounded-lg px-4 py-3 text-sm font-medium text-white shadow-lg ${status === 'applying' ? 'bg-slate-800' : status === 'error' ? 'bg-red-600' : 'bg-emerald-600'}`}
    >
      {status === 'applying' ? (
        <>
          <svg className="h-5 w-5 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          Applying changes...
        </>
      ) : status === 'error' ? (
        <>
          <span aria-hidden="true">!</span>
          {error}
        </>
      ) : (
        <>
          <span aria-hidden="true">✓</span>
          Changes applied successfully.
        </>
      )}
    </div>
  );
};
